import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData, basicFormData } from "./MaterialIntakeFile.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import formatDateTime from "../../../custom/Utils/formatDateTime.js";

const MaterialIntakeView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  

  const getEditData = async (id) => {

    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({inputData:data})
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>
                            Material Intakes Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >

                              <p>
                                <strong>Intake No: </strong>
                                {formData?.inputData?.intake_no || "-"}
                              </p>
                              <p>
                                <strong>Material Code: </strong>
                                {formData?.inputData?.material?.code || "-"}
                              </p>
                              <p>
                                <strong>Material Name: </strong>
                                {formData?.inputData?.material?.name || "-"}
                              </p>
                              <p>
                                <strong>Customer Name: </strong>
                                {formData?.inputData?.customer?.client_name || "-"}
                              </p>

                              <p>
                                <strong>Issue Descriptions: </strong>
                                {formData?.inputData?.issue_descriptions || "-"}
                              </p>
                              <p>
                                <strong>Received By: </strong>
                                {formData?.inputData?.received_by_user?.first_name || "-"} {" "}
                                {formData?.inputData?.received_by_user?.last_name || "-"}
                              </p>
                              <p>
                                <strong>Inspected By: </strong>
                                {formData?.inputData?.inspected_by_user?.first_name || "-"} {" "}
                                {formData?.inputData?.inspected_by_user?.last_name || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                            

                              <p>
                                <strong>Inspected Remark: </strong>
                                {formData?.inputData?.inspected_remark || "-"}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.status || "-"}
                              </p>
                              <p>
                                <strong>Received At: </strong>
                                {formData?.inputData?.received_date === null ? "NA" : formatDateTime(formData?.inputData?.received_date)}
                              </p>
                              <p>
                                <strong>Is Active: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created At: </strong>
                                {formData?.inputData?.createdAt === null ? "NA" : formatDateTime(formData?.inputData?.createdAt)}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {formData?.inputData?.updatedAt === null ? "NA" : formatDateTime(formData?.inputData?.updatedAt)}
                              </p>
                              
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MaterialIntakeView;
